import moment from "moment";
import { Component, Provide, Prop } from "vue-property-decorator";
import { FeatureFlagModuleEnum } from "../../../dto/GenApi.iNotPaie.Dto/FeatureFlagModuleEnum";
import { TypeCalendrier } from "../../../shared/models/typeCalendrier";
import { EventBus } from "../../Controls/EventBus";
import EventConstants from "../../Controls/EventConstants";
import { FeatureFlagManagerInstance } from "../../Controls/FeatureFlagManager";
import { ParametresInstance } from "../../Controls/Parameters";
import { VueBase } from "../../Controls/VueBase";
import { ServicesFactoryInstance } from "../../Controls/ServicesFactory";
import { OngletAccueilSalarieEnum } from "../gestionDesAbsencesV2";

const CalendrierV1 = require("../../calendrier/calendrier.vue.html");
const CalendrierV3 = require("../calendrierMensuel/calendrierMensuel.vue.html");

@Component({
    components: {
        CalendrierV1,
        CalendrierV3,
        CalendrierEquipe: require("../calendrierEquipe/calendrierEquipe.vue.html"),
        ModalAjoutConge: require("../modalAjoutConge/modalAjoutConge.vue.html")
    }
})
export default class PlanningCongeComponent extends VueBase {
    @Prop({ required: true }) public type!: string;

    public calendrier = null;
    public TypeCalendrier = TypeCalendrier;
    public modalAbsenceVisible: boolean = false;
    public exercice: Date | undefined = undefined;
    public absenceToModifyId: number | null = null;
    public activeTab: string = "MonPlanning";
    public showTabV3: boolean = false;
    public showTabV4: boolean = false;
    public showAutresSalariesTabV3: boolean = false;
    public showAutresSalariesTabV4: boolean = false;
    public showAllSalariesTabV4: boolean = false;

    public mounted(): void {
        EventBus.$on(EventConstants.SOCIETE_CHANGED, () => {
            this.setCalendrier();
            this.setExercice();
        });

        if (ParametresInstance.societeCourante !== undefined) {
            this.setCalendrier();
            this.setExercice();
        }
    }

    /**
     * Ouvre la modale de modification d'absence
     * @param absenceId ID de l'absence à modifier
     */
    @Provide("modifyAbsence")
    public openModalAbsenceModify(absenceId: number): void {
        this.absenceToModifyId = absenceId;
        this.modalAbsenceVisible = true;
    }

    /**
     * Ouvre la popup d'ajout d'absence
     */
    public openModalAbsence(): void {
        this.modalAbsenceVisible = true;
    }

    /**
     * Ferme la modale et réinitialise l'ID de l'absence à modifier
     */
    public closeModalAbsence(): void {
        this.modalAbsenceVisible = false;
        this.absenceToModifyId = null;
    }

    /**
     * Set le dernier exercice 
     */
    private setExercice(): void {
        this.exercice = moment.utc(ParametresInstance?.societeCourante?.DernierExercice).toDate();
    }

    private setCalendrier(): void {
        const isV3Enabled = FeatureFlagManagerInstance.hasFeatureFlag(FeatureFlagModuleEnum.ModuleCongeV3);
        const isV4Enabled = FeatureFlagManagerInstance.hasFeatureFlag(FeatureFlagModuleEnum.ModuleCongeV4);

        if (isV3Enabled && !isV4Enabled) {
            this.showTabV3 = true;
            this.checkCanViewSalariesV3();
        }

        if (isV3Enabled && isV4Enabled) {
            this.showTabV4 = true;
            this.checkCanViewSalariesV4();
        }

        this.calendrier = isV3Enabled ? CalendrierV3 : CalendrierV1;
    }

    /**
     * Vérifie si le salarié connecté verra apparaître d'autres salariés dans le planning
     */
    private checkCanViewSalariesV3(): void {
        // Si pas de société, on ne peut pas voir les autres salariés
        if (!ParametresInstance.societeCourante) {
            this.showAutresSalariesTabV3 = false;
            this.showAutresSalariesTabV4 = false;
            return;
        }

        // Vérifie si le salarié peut voir d'autres salariés
        ServicesFactoryInstance.StatuAbsenceService.canViewOtherEmployees((result) => {
            this.showAutresSalariesTabV3 = result;

            this.restaureMonPlanning();
        }, () => {
            // En cas d'erreur, ne pas afficher les tabs
            this.showTabV3 = false;

            if (this.activeTab === "AutreSalaries") {
                this.activeTab = "MonPlanning";
            }
        });
    }

    /**
     * Restaure le tab "Mon planning" si on ne peut pas voir d'autres salariés
     */
    private restaureMonPlanning(): void {
        // Si on ne peut pas/plus voir d'autres salariés, on revient au tab "Mon planning"
        if ((!this.showAutresSalariesTabV3 || !this.showAutresSalariesTabV4) && (this.activeTab === "AutreSalaries" || this.activeTab === "TousSalaries")) {
            this.activeTab = "MonPlanning";
        }
    }

    /**
     * Vérifie si le salarié connecté verra apparaître tous les salariés dans le planning
     */
    private checkCanViewSalariesV4(): void {
        // Si pas de société, on ne peut pas voir les autres salariés
        if (!ParametresInstance.societeCourante) {
            this.showAutresSalariesTabV3 = false;
            this.showAutresSalariesTabV4 = false;
            return;
        }

        // Vérifie si le salarié peut voir d'autres salariés
        ServicesFactoryInstance.StatuAbsenceService.employeesVisibility((result) => {
            this.showAllSalariesTabV4 = result.CanViewAllEmployees;
            this.showAutresSalariesTabV4 = result.CanViewTeamOrServiceEmployees;

            this.restaureMonPlanning();
        }, () => {
            // En cas d'erreur, ne pas afficher les tabs
            this.showTabV4 = false;

            if (this.activeTab === "AutreSalaries" || this.activeTab === "TousSalaries") {
                this.activeTab = "MonPlanning";
            }
        });
    }

    public get canShow(): boolean {
        return this.type === OngletAccueilSalarieEnum.Planning;
    }
}



// WEBPACK FOOTER //
// ./src/components/gestionDesAbsencesV2/planningConge/planningConge.ts